import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  Property,
  SectionConfig,
} from '../../../../../dto/response/template.config';
import { TemplateConfigService } from '../../../../../service/template-config.service';

@Component({
  selector: 'app-footer-logo',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './footer-logo.component.html',
  styleUrl: './footer-logo.component.scss',
})
export class FooterLogoComponent {
  logo: Property | undefined;
  _config!: SectionConfig;

  constructor(private templateConfigService: TemplateConfigService) {}

  @Input()
  set footerConfig(config: SectionConfig) {
    this._config = config;
    this.logo = this.templateConfigService.findConfig(config, 'logo');
  }
}
